module.exports = __webpack_public_path__ + "img/ch32.4935d3c0.png";